module.exports = __webpack_public_path__ + "img/lift4.e8f2d995.jpg";